<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入物流商</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="`/supply/logistics/download/import/template`"
          @uploadAfter="uploadAfter"
          container-type="logistics"
          style="margin-bottom: 10px;">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '重复导入同个物流商数据将覆盖原有数据',
            '同一个物流商名称或同一个供应商编码存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>

  import {modalMixIn, uploadMixin} from "../../../../../minxins";
  import {importLogisticsProvider} from "../../../../../api/logistics";

  export default {
    name: "app-import-logistics-provider-modal",
    mixins: [modalMixIn, uploadMixin],
    data() {
      return {
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importLogisticsProvider(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>
